import { render, staticRenderFns } from "./CatalogSuppliers.vue?vue&type=template&id=7317f8a6"
import script from "./CatalogSuppliers.vue?vue&type=script&lang=js"
export * from "./CatalogSuppliers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports